import React, { useCallback, useState, Fragment } from 'react';
import Button from '../../../../../components/Button';
import CountOfTotal from '../../../../../components/CountOfTotal';
import BaseForm from '../../../../../components/form/BaseForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import Select from '../../../../../components/input/Select/Select';
import Panel from '../../../../../components/outline/Panel';
import {
  MAXIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT,
  MAXIMUM_NUMBER_OF_RECOMMEND_EVENT_MEMO,
  MINIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT,
  RECOMMEND_EVENT_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/recommendEventConstants';
import recommendEventSearchInfo from '../../../../../static/images/recommend/event/recommend-event-search-info.png';
import RecommendSearchInfoDrawer from '../../../common/RecommendSearchInfoDrawer';
import './RecommendEventSaveInfo.scss';

const RecommendEventSaveInfo = (props) => {
  const { form, setData, recommendEventInfo, typeDisabled } = props;
  const { type, memo } = recommendEventInfo;

  const [drawerVisible, setDrawerVisible] = useState(false);

  const toggleDrawerVisible = useCallback(() => {
    setDrawerVisible(!drawerVisible);
  }, [drawerVisible]);

  return (
    <Panel className="recommend-event-save-info">
      <div className="panel-header">
        <div className="title">추천 기획전 정보</div>
        <Button isRadius color="primary" text="설명보기" onClick={toggleDrawerVisible} />
      </div>

      <div className="panel-body">
        {/* 추천 기획전 타입 */}
        <BaseForm
          label="추천 타입"
          content={
            <Select
              list={RECOMMEND_EVENT_TYPE_SELECT_LIST}
              onChange={(value) =>
                setData({
                  path: ['recommendEventSave', 'recommendEventInfo', 'type'],
                  value,
                })
              }
              defaultValue={type}
              value={type}
              disabled={typeDisabled}
              isTable={false}
            />
          }
        />

        {/* 메모 */}
        <TextAreaForm
          form={form}
          label={
            <span>
              메모
              <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_RECOMMEND_EVENT_MEMO} />
            </span>
          }
          initialValue={memo}
          maxLength={MAXIMUM_NUMBER_OF_RECOMMEND_EVENT_MEMO}
          onChange={(value) =>
            setData({
              path: ['recommendEventSave', 'recommendEventInfo', 'memo'],
              value,
            })
          }
          name="memo"
          autoSize={{ minRows: 4, maxRows: 8 }}
        />
      </div>

      <RecommendSearchInfoDrawer
        title="추천 기획전 - 검색 추천"
        visible={drawerVisible}
        onClose={toggleDrawerVisible}
        imgUrl={recommendEventSearchInfo}
      >
        <Fragment>
          <div>*앱에서 기획전 검색 탭에서 추천되는 기획전 리스트입니다.</div>
          <div>
            *추천 기획전 리스트는 최소 {MINIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT}개, 최대{' '}
            {MAXIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT}개입니다.{' '}
          </div>
        </Fragment>
      </RecommendSearchInfoDrawer>
    </Panel>
  );
};

export default RecommendEventSaveInfo;
